/**
 * Lets any `?` marker open the guide at its own section without every panel
 * having to thread a callback down from the shell.
 *
 * The default is a no-op rather than a throw: panels are rendered on their own
 * in tests and in the print path, and a missing provider should cost the reader
 * a link, not a crash.
 */

import { createContext, useContext } from 'react';
import type { TopicId } from './glossary.tsx';

export interface GuideApi {
  open: (topic?: TopicId) => void;
}

export const GuideContext = createContext<GuideApi>({ open: () => {} });

export function useGuide(): GuideApi {
  return useContext(GuideContext);
}
